import { DashboardId } from '@blisspointmedia/bpm-types/dist/dashboarding';
import { FilterNode } from '@blisspointmedia/bpm-types/dist/querying';
import { useMirroredValue, usePublishMirroredValue } from './useMirroredValue';

interface DashboardViewSnapshot {
  dashboardFilters: FilterNode[];
  dateRange: { start: string; end: string };
}

const VIEW_SNAPSHOT_SCOPE = 'dashboard-view-snapshot';

// The filters and date window on screen, so the agent is grounded on the live view.
export const useDashboardViewSnapshot = (
  company: string,
  dashboardId: DashboardId | null
): DashboardViewSnapshot | null =>
  useMirroredValue<DashboardViewSnapshot>(VIEW_SNAPSHOT_SCOPE, company, dashboardId);

export const usePublishDashboardViewSnapshot = (
  company: string,
  dashboardId: DashboardId | null,
  snapshot: DashboardViewSnapshot
): void => usePublishMirroredValue(VIEW_SNAPSHOT_SCOPE, company, dashboardId, snapshot);
